/**
 * @typedef Locations
 * @param axios
 * @returns {{get(): Promise}}
 */
export const Locations = axios => ({
  /**
   * @param {String} keyword
   * @param {String} type
   * @returns Promise
   */
  get(keyword, type) {
    return axios.get('/v1/locations', {
      params: {
        keyword,
        type
      }
    })
  },

  /**
   * @param {String} search
   * @param {String[]} types
   * @returns Promise
   */
  getLocal(search, types) {
    return axios.get('/v1/locations/local', {
      params: {
        search,
        types
      }
    })
  }
})
